/** Auth params Supabase may append to query or hash after email / OAuth redirects. */
export function readAuthRedirectParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const hashParams = new URLSearchParams(
    window.location.hash.replace(/^#/, ""),
  );

  return {
    code: searchParams.get("code") ?? hashParams.get("code"),
    error: searchParams.get("error") ?? hashParams.get("error"),
    errorDescription:
      searchParams.get("error_description") ??
      hashParams.get("error_description"),
    type: searchParams.get("type") ?? hashParams.get("type"),
  };
}

export function hasAuthRedirectParams(): boolean {
  const { code, error } = readAuthRedirectParams();
  return Boolean(code || error);
}

export function clearAuthRedirectParams(): void {
  const url = new URL(window.location.href);
  url.search = "";
  url.hash = "";
  window.history.replaceState(window.history.state, "", url.pathname);
}

export type PasswordResetLinkErrorKind = "expired" | "invalid";

export function getPasswordResetLinkError(
  rawMessage: string | null | undefined,
): { kind: PasswordResetLinkErrorKind; message: string } {
  const normalized = (rawMessage ?? "").trim().toLowerCase();

  if (
    normalized.includes("expired") ||
    normalized.includes("otp has expired")
  ) {
    return {
      kind: "expired",
      message:
        "This password reset link has expired. Links are only valid for a limited time.",
    };
  }

  if (rawMessage?.trim()) {
    return {
      kind: "invalid",
      message: rawMessage.trim(),
    };
  }

  return {
    kind: "invalid",
    message:
      "This password reset link is invalid or has already been used.",
  };
}
